export const CONFIRM_USER_COMPANY_ROLE_START =
  'CONFIRM_USER_COMPANY_ROLE_START';
export const CONFIRM_USER_COMPANY_ROLE_SUCCESS =
  'CONFIRM_USER_COMPANY_ROLE_SUCCESS';
export const CONFIRM_USER_COMPANY_ROLE_FAIL = 'CONFIRM_USER_COMPANY_ROLE_FAIL';

export const DECLINE_USER_COMPANY_ROLE_START =
  'DECLINE_USER_COMPANY_ROLE_START';
export const DECLINE_USER_COMPANY_ROLE_SUCCESS =
  'DECLINE_USER_COMPANY_ROLE_SUCCESS';
export const DECLINE_USER_COMPANY_ROLE_FAIL = 'DECLINE_USER_COMPANY_ROLE_FAIL';

export type CompanyActionTypes =
  | typeof CONFIRM_USER_COMPANY_ROLE_START
  | typeof CONFIRM_USER_COMPANY_ROLE_SUCCESS
  | typeof CONFIRM_USER_COMPANY_ROLE_FAIL
  | typeof DECLINE_USER_COMPANY_ROLE_START
  | typeof DECLINE_USER_COMPANY_ROLE_SUCCESS
  | typeof DECLINE_USER_COMPANY_ROLE_FAIL;
